import { enhancePrisma } from "blitz"
import { PrismaClient } from "@prisma/client"
import chalk from "chalk"
import { logger } from "utils/logger"
import { clientEnv } from "config"

const EnhancedPrisma = enhancePrisma(PrismaClient)

export * from "@prisma/client"
const db = new EnhancedPrisma({ log: [{ level: "query", emit: "event" }] })

if (clientEnv.isDevelopment && db.$on && !global["queryLogAdded"]) {
  db.$on("query", (event: any) => {
    logger.debug(
      chalk.dim(
        event.duration,
        event.query
          .replace(/"public"\./g, "")
          .replace(new RegExp(`(?<=SELECT)(.*)(?=FROM)`, "g"), " "),
        event.params
      )
    )
  })
  global["queryLogAdded"] = true
}

export default db
